import alt from '../alt';
import si from 'si';


class ReceiptActions {
    constructor() {}

    changeField(name, value){
        var diff = {};
        diff[name] = value;
        return diff;
    }


	getGuestOrderDetail(OrderID, email){
		si.getGuestOrderDetail(OrderID, email).then(this.orderDetailSuccess, this.orderDetailFailure);
		return true;
	}
	
	getGuestOrderById(OrderId) {
		si.getOrderDetail(OrderId).then(this.orderDetailSuccess, this.orderDetailSuccess);
	}

	setFromOrderFlag(flag) {
		return flag;
	}

    resetOrderDetail() {
        return true;
    }

	orderDetailSuccess(data) {
		return data
	}
	
	orderDetailFailure(data) {
		return data
	}


}


export default alt.createActions(ReceiptActions);


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/GuestCheckout/ReceiptActions.js